import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import dayjs from 'dayjs'
import { useConfirm } from 'material-ui-confirm'
import { FunctionComponent, useEffect, useMemo } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import useAuth from '../../../../base/hooks/useAuth'
import { getEntidadInput } from '../../../../utils/getEntidadInput'
import { notSuccess } from '../../../../utils/notification'
import { swalClose, swalException, swalLoading } from '../../../../utils/swal'
import { apiLoteRegistro } from '../../api/apiLoteRegistro'
import {
  actionLoteForm,
  LOTE_INITIAL_VALUES,
  LoteInputProps,
  LoteProps,
} from '../../interfaces'
import { loteRegistroComposeService } from '../../services/loteRegistroComposeService'
import { LoteRegistroValidationSchema } from '../../validator/loteRegistro.validator'
import LoteForm from '../LoteForm'

interface OwnProps {
  id: string
  keepMounted: boolean
  open: boolean
  onClose: (value?: LoteProps) => void
}

type Props = OwnProps

/**
 * Dialogo para upsert de lotes
 * @param props
 * @constructor
 */
const LoteRegistroDialog: FunctionComponent<Props> = (props) => {
  const { onClose, open, ...other } = props
  const form = useForm<LoteInputProps>({
    defaultValues: { ...LOTE_INITIAL_VALUES },
    resolver: yupResolver<any, any, any>(LoteRegistroValidationSchema),
  })
  const confirm = useConfirm()

  const { user } = useAuth()
  const entidad = useMemo(() => getEntidadInput(user), [user])

  const actionForm = actionLoteForm.REGISTER

  /**
   * @description Guardamos los cambios en la entrada
   * @param values
   */
  const onSubmit: SubmitHandler<LoteInputProps> = async (values) => {
    const apiInput = loteRegistroComposeService(values)
    const { confirmed } = await confirm({})
    if (!confirmed) return
    try {
      swalLoading()
      const resp = await apiLoteRegistro(values.codigoLote, apiInput, entidad)
      if (resp) {
        notSuccess('Registro exitoso')
        swalClose()
        onClose(resp)
      }
    } catch (e: any) {
      swalException(e)
    }
  }

  const onError = (errors: any, e: any) => console.log(errors, e)
  useEffect(() => {
    if (open) {
      form.reset({
        ...LOTE_INITIAL_VALUES,
        fechaAdmision: dayjs(new Date()),
      })
    }
  }, [open])

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { maxHeight: '80vh' } }}
      maxWidth="sm"
      fullWidth
      open={open}
      {...other}
    >
      <DialogTitle>Nuevo Lote</DialogTitle>
      <DialogContent dividers>
        <LoteForm form={form} action={actionForm} />
      </DialogContent>
      <DialogActions>
        <Button color={'error'} size={'small'} onClick={() => onClose()}>
          Cancelar
        </Button>
        <Button
          onClick={form.handleSubmit(onSubmit, onError)}
          size={'small'}
          sx={{ mr: 2 }}
          variant={'contained'}
        >
          Registrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LoteRegistroDialog
